<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Icon-App_guide" data-name="Icon-App guide">
          <circle
            id="Ellipse_5"
            data-name="Ellipse 5"
            fill="#A5D867"
            class="cls-1"
            cx="18.5"
            cy="18.5"
            r="18.5"
          />
          <g id="Icon-Guide">
            <g id="Group_102" data-name="Group 102">
              <path
                id="Polygon_1"
                data-name="Polygon 1"
                fill="#383935"
                class="cls-2"
                d="M18.5,9,22,15H15Z"
              />
              <path
                id="Polygon_2"
                data-name="Polygon 2"
                fill="#383935"
                class="cls-2"
                d="M18.5,29,15,23h7Z"
              />
            </g>
            <g id="Group_103" data-name="Group 103">
              <path
                id="Polygon_1-2"
                data-name="Polygon 1-2"
                fill="#383935"
                class="cls-2"
                d="M8.16,19l6.53-3.26v6.53Z"
              />
              <path
                id="Polygon_2-2"
                data-name="Polygon 2-2"
                fill="#383935"
                class="cls-2"
                d="M28.84,19l-6.53,3.27V15.78Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'AppGuide_Icon',
  }
</script>

<style scoped>
  svg {
    width: 37px;
    height: 37px;
  }
</style>
